import { TChartClick } from '../types'

export const EMPTY_CHART_CLICK: TChartClick = {
  datasetIndex: 0,
  datasetLabel: '',
  index: 0,
  label: '',
  position: { left: 0, top: 0 },
  value: 0
}
